import React from 'react';
import { useOfferContext } from '../../../context';
import { Title } from '../../../components/Title';

export function TitleContainer() {
  const { title, subtitle, isTop } = useOfferContext();

  return <Title isTop={isTop} title={title} subtitle={subtitle} />;
}
